module.exports = __webpack_public_path__ + "img/logo.a517b243.png";